import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { environment } from '@environments/environment';

@Component({
    selector: 'app-dialog-private-cert-destroy',
    templateUrl: './dialog-private-cert-destroy.component.html',
    styles: [],
    standalone: false
})
export class DialogPrivateCertDestroyComponent implements OnInit {
  public isMobile: boolean;
  constructor(
    public dialogRef: MatDialogRef<DialogPrivateCertDestroyComponent>,
    @Inject(MAT_DIALOG_DATA) public data
  ) {
    this.isMobile = environment.platform === 'mobile';
  }

  ngOnInit() {
  }

  onNoClick(): void {
    this.dialogRef.close();
  }
}
